import React from 'react';
import { AiOutlineTwitter } from 'react-icons/ai';
import { FaFacebookF, FaHome } from 'react-icons/fa';
import { IoMdCall } from 'react-icons/io';
import { MdEmail, MdOutlineWifi } from 'react-icons/md';
import { TiSocialGooglePlus } from 'react-icons/ti';

const Footer = () => {
    return (
        <div className='bg-[#EFE6DA] pt-16 text-center md:text-start' style={{ fontFamily: "Merienda" }}>
            <div>
                <div className='main grid-cols-1 md:grid md:grid-cols-2 lg:grid-cols-4 lg:gap-x-4  md:gap-x-6 '>
                    {/* 1  */}
                    <div className='mb-10'>
                        <h3 className='footer-title'>About Us</h3>
                        <p className='pragraph mb-4 hover:text-[#E27900] delay-300'>Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.</p>
                        <ul>
                            <li className='flex hover:text-[#E27900] delay-300 pragraph'>
                                <span className="inline-block mt-1 mr-2"> <MdEmail className='' /></span>
                                <span className="block">hello@mtheme.org</span>
                            </li>
                            <li className='flex hover:text-[#E27900] delay-300 pragraph'>
                                <span className="inline-block mt-1 mr-2"> <IoMdCall className='' /></span>
                                <span className="block">+(84)123456789</span>
                            </li>
                            <li className='flex hover:text-[#E27900] delay-300 pragraph'>
                                <span className="inline-block mt-1 mr-2"> <FaHome className='' /></span>
                                <span className="block ">198 West 21th Street, Suite 721 New York NY 10010</span>
                            </li>
                        </ul>
                    </div>
                    {/* 2  */}
                    <div className='mb-10'>
                        <h3 className='footer-title'>For Business</h3>
                        <ul>
                            <li className='fooList-fl pragraph'>Office Coffee</li>
                            <li className='fooList-fl pragraph'>Food Service</li>
                            <li className='fooList-fl pragraph'>Affiliate Program</li>
                        </ul>
                    </div>
                    {/* 3  */}
                    <div className='mb-10'>
                        <h3 className='footer-title'>Newsletter</h3>
                        <p className='pragraph mb-4 hover:text-[#E27900] delay-300'>If you world like sign-up to the origin newsletter,please enter your email address below</p>
                        <div>
                            <input className='input-field' type="text" placeholder='Name' />

                            <input className='input-field' type="email" placeholder='Email' />

                            <button className='sub-btn'>Subscribe</button>
                        </div>
                    </div>
                    {/* 4  */}
                    <div className='mb-10'>
                        <h3 className='footer-title'>Follow Us</h3>
                        <p className='pragraph mb-4'>Follow Origin on the following social network sites.</p>
                        <div className='flex md:space-x-4 md:justify-center gap-x-5'>
                            <FaFacebookF className='text-black hover:bg-[#E27A01] hover:text-white delay-200 text-4xl bg-white p-2 cursor-pointer' />
                            <AiOutlineTwitter className='text-black hover:bg-[#E27A01] hover:text-white delay-200 text-4xl bg-white p-2 cursor-pointer' />
                            <TiSocialGooglePlus className='text-black hover:bg-[#E27A01] hover:text-white delay-200 text-4xl bg-white p-2 cursor-pointer' />
                            <MdOutlineWifi className='text-black hover:bg-[#E27A01] hover:text-white delay-200 text-4xl bg-white p-2 cursor-pointer' />
                        </div>
                    </div>

                </div>
                {/* copyright-area  */}
                <hr className='border  border-b-[#dad1c2] mt-5' />
                <div className='main text-center py-5'>
                    <p className='text-sm'>Copyright © 2022 by <b className='uppercase font-medium text-[#E27900]'>Saifun Nahar Sumi</b>. All Rights Reserved. </p>
                </div>
            </div>



        </div>
    );
};

export default Footer;